// extracted by mini-css-extract-plugin
export default {"searchBox":"Searchbox_searchBox__cWPAU","action":"Searchbox_action__29UKv"};